import { render, staticRenderFns } from "./WebmailAccessModal.vue?vue&type=template&id=1f753c36&"
import script from "./WebmailAccessModal.vue?vue&type=script&lang=js&"
export * from "./WebmailAccessModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f753c36')) {
      api.createRecord('1f753c36', component.options)
    } else {
      api.reload('1f753c36', component.options)
    }
    module.hot.accept("./WebmailAccessModal.vue?vue&type=template&id=1f753c36&", function () {
      api.rerender('1f753c36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Email/Accounts/Modals/WebmailAccessModal.vue"
export default component.exports